var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0964 0.390159L3.93638 7.30016L2.03638 5.27016C1.68638 4.94016 1.13638 4.92016 0.736381 5.20016C0.346381 5.49016 0.236381 6.00016 0.476381 6.41016L2.72638 10.0702C2.94638 10.4102 3.32638 10.6202 3.75638 10.6202C4.16638 10.6202 4.55638 10.4102 4.77638 10.0702C5.13638 9.60016 12.0064 1.41016 12.0064 1.41016C12.9064 0.490159 11.8164 -0.31984 11.0964 0.38016V0.390159Z",
    fill: "#079455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.2674fd764883e21cca34a7ae498712a9.svg";
export { ForwardRef as ReactComponent };